__turbopack_context__.v({
  "bordered": "Button-module-scss-module__HB5Z3q__bordered",
  "borderless": "Button-module-scss-module__HB5Z3q__borderless",
  "button": "Button-module-scss-module__HB5Z3q__button",
  "disabled": "Button-module-scss-module__HB5Z3q__disabled",
  "font-accent": "Button-module-scss-module__HB5Z3q__font-accent",
  "font-special": "Button-module-scss-module__HB5Z3q__font-special",
  "namespace": "Button-module-scss-module__HB5Z3q__namespace",
  "primary": "Button-module-scss-module__HB5Z3q__primary",
  "short": "Button-module-scss-module__HB5Z3q__short",
  "standard": "Button-module-scss-module__HB5Z3q__standard",
});
